import {
  SubFooter,
  SocialButton,
  SideCart,
  Header,
  Footer,
  Content,
  Banner,
  AdminSidebar,
  AdminFooter,
  AdminHeader,
  DashboardWidget,
  DashboardData,
} from "../widget";
const widgets: any = {
  SubFooter,
  SocialButton,
  SideCart,
  Header,
  Footer,
  Content,
  Banner,
  AdminSidebar,
  AdminFooter,
  AdminHeader,
  DashboardWidget,
  DashboardData,
};
export const useWidget = (widget: string) => {
  return widgets[widget];
};
;
